import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../Axios';
import { toggleReferralModal } from 'reducers/UiReducer';



const getAxiosConfig = (token) => ({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

const getErrorMessage = (error) =>
  error.response && error.response.data.message
    ? error.response.data.message
    : error.message;

const ReferralReducer = createSlice({
  name: 'referral',
  initialState: {
    success: false,



    // Referral states
    referralLoading: false,
    referralList: [],
    referralError: null,
    referralStatusList: [],

    
  },
  reducers: {

 

    // Referral actions
    createReferralRequest(state) {
      state.referralLoading = true;
    },
    createReferralSuccess(state, action) {
      state.referralLoading = false;
      // state.referralList.push(action.payload);
    },
    createReferralFail(state, action) {
      state.referralLoading = false;
      state.referralError = action.payload;
    },
    updateReferralRequest(state) {
      state.referralLoading = true;
    },
    updateReferralSuccess(state, action) {
      state.referralLoading = false;

    },
    updateReferralFail(state, action) {
      state.referralLoading = false;
      state.referralError = action.payload;
    },
    getReferralListRequest(state) {
      state.referralLoading = true;
    },
    getReferralListSuccess(state, action) {
      state.referralLoading = false;
      state.referralList = action.payload;
    },
    getReferralListFail(state, action) {
      state.referralLoading = false;
      state.referralError = action.payload;
    },
    deleteReferralRequest(state) {
      state.referralLoading = true;
    },
    deleteReferralSuccess(state, action) {
      state.referralLoading = false;

    },
    deleteReferralFail(state, action) {
      state.referralLoading = false;
      state.referralError = action.payload;
    },

 getReferralStatusListSuccess(state, action) {
      state.referralLoading = false;
      state.referralStatusList = action.payload;
    },

   getReferralStatusListFail(state, action) {
      state.referralLoading = false;
      state.referralError = action.payload;
    },

    updateReferralStatusFail(state, action) {
      state.referralLoading = false;
      state.referralError = action.payload;
    },
     updateReferralStatusSuccess(state, action) {
      state.referralLoading = false;

    },

     updateReferralStatusRequest(state) {
      state.referralLoading = true;
    },

  },
});

export const {





  
  // Referral actions
  createReferralRequest,
  createReferralSuccess,
  createReferralFail,
  updateReferralRequest,
  updateReferralSuccess,
  updateReferralFail,
  getReferralListRequest,
  getReferralListSuccess,
  getReferralListFail,

  deleteReferralRequest,
  deleteReferralSuccess,
  deleteReferralFail,
  getReferralStatusListSuccess,
  getReferralStatusListFail,
  updateReferralStatusFail,
  updateReferralStatusSuccess,
  updateReferralStatusRequest,




  

} = ReferralReducer.actions;







export const createReferralDispatch = (referralData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(createReferralRequest());
    const { data } = await axiosInstance.post('/User/ReferralRegister', referralData, config);

    if (data.status === 1) {
      dispatch(createReferralSuccess());
      dispatch(getReferralListDispatch(referralData, token));
      dispatch(toggleReferralModal(false));
    }
  } catch (error) {
    dispatch(
      createReferralFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

export const updateReferralDispatch = (referralData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updateReferralRequest());
    const { data } = await axiosInstance.post(`/Referral/UpdateReferral`, referralData, config);
    if (data.status === 1) {
      dispatch(updateReferralSuccess());
      dispatch(getReferralListDispatch(referralData, token));
      dispatch(toggleReferralModal(false));
    }

  } catch (error) {
    dispatch(
      updateReferralFail(
        error.response?.data?.message || error.message
      )
    );
  }
};



export const getReferralListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getReferralListRequest());

    const { offset = 0, recordcount = 10, fullName = '' } = form;

    const queryParams = new URLSearchParams({
      offset: offset.toString(),
      recordcount: recordcount.toString(),
      FullName: fullName
    });

    const { data } = await axiosInstance.get(
      `/Referral/GetReferralList?${queryParams.toString()}`,
      getAxiosConfig(token)
    );

    dispatch(getReferralListSuccess(data));
  } catch (error) {
    dispatch(getReferralListFail(getErrorMessage(error)));
  }
};




export const deleteReferralDispatch = (ReferralId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deleteReferralRequest());
    await axiosInstance.delete(`/referral/DeleteReferralById/${ReferralId}`, config);
    dispatch(deleteReferralSuccess());
  } catch (error) {
    dispatch(
      deleteReferralFail(
        error.response?.data?.message || error.message
      )
    );
  }
};


export const getReferralStatusListDispatch = (row, token) => async (dispatch) => {
  try {
    
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axiosInstance.get('/ReferralStatus/GetReferralStatusList', config);

    dispatch(getReferralStatusListSuccess(data.data)); // expecting an array of { id, statusName }
    console.log('Referral status response:', data);
  } catch (error) {
     dispatch(
      getReferralStatusListFail(
        error.response?.data?.message || error.message
      )
    )
  }
};

export const updateReferralStatusDispatch = (referralId, status,point, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    const payload = {
      ReferralId: referralId,
      StatusId: status, // Adjust this to match your backend (e.g., statusId)
      Point: point, // Include point if needed
    };

console.log('Updating referral status with payload:', payload);

    dispatch(updateReferralStatusRequest());

    await axiosInstance.post('/Referral/UpdateReferralStatus', payload, config);

   dispatch(updateReferralStatusSuccess());
    dispatch(getReferralListDispatch({}, token)); // Optionally refresh the list
  } catch (error) {
    dispatch(
       updateReferralStatusFail(
         error.response?.data?.message || error.message
       )
    );
  }
};




export default ReferralReducer;
